import { render, staticRenderFns } from "./DocumentAlert.vue?vue&type=template&id=4b3d4dec&scoped=true&"
import script from "./DocumentAlert.vue?vue&type=script&lang=js&"
export * from "./DocumentAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3d4dec",
  null
  
)

export default component.exports